<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Campaña</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Campaña</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.FechaDesde}}</mat-label>
                        <input readonly matInput [matDatepicker]="picker" formControlName="fechaDesde">

                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error
                            *ngIf="(form.get('fechaDesde').hasError('required')) && form.get('fechaDesde').touched ">
                            {{Validaciones.FechaDesde}}
                        </mat-error>
                    </mat-form-field>
                </div>
                
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.FechaHasta}}</mat-label>
                        <input readonly matInput [matDatepicker]="picker2" formControlName="fechaHasta">

                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                        <mat-error
                            *ngIf="(form.get('fechaHasta').hasError('required')) && form.get('fechaHasta').touched ">
                            {{Validaciones.FechaHasta}}
                        </mat-error>
                    </mat-form-field>

                </div>
            </div>

        </div>


    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" (click)="guardarCampania()" [disabled]="form.invalid" mat-flat-button
        color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>